import { AdminApiError, type AdminEnvelope } from './_core.js';

export interface RefundResponse {
  userId: string;
  amountNano: string;
  newBalanceNano: string;
  reason: string;
}

export async function postRefund(input: {
  userId: string;
  amountNano: string;
  reason: string;
}): Promise<RefundResponse> {
  const res = await fetch('/api/admin/refunds', {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(input),
  });
  const json = (await res.json().catch(() => null)) as AdminEnvelope<RefundResponse> | null;
  if (!res.ok || !json || !('success' in json) || json.success !== true) {
    const code = json && 'error' in json ? json.error.code : 'refund_failed';
    const msg = json && 'error' in json ? json.error.message : 'refund failed';
    throw new AdminApiError(res.status, code, msg);
  }
  return json.data;
}
